
export function normalizeRows(context, rows) {
  switch (context) {
    case "NETSUITE_SO_WIP":
      return normalizeWIP(rows);
    case "NETSUITE_SO_AR":
      return normalizeAR(rows);
    case "FACILIS_SJ":
      return normalizeFacilisSJ(rows);
    case "FACILIS_OJ":
      return normalizeFacilisOJ(rows);
    default:
      throw new Error(`Unknown context: ${context}`);
  }
}

function normalizeWIP(rows) {
  return rows
    .filter(row =>
      row["Document Number"] &&
      row["Customer"] &&
      row["Status"]
    )
    .map(row => ({
      context: "NETSUITE_SO_WIP",
      account: row["Account"] ?? null,
      date: excelDateToISO(row["Date"]),
      document_number: row["Document Number"] ?? null,
      customer: row["Customer"] ?? null,
      status: row["Status"] ?? null,
      open_amount: parseCurrency(row["Open Amount"]),
      sales_rep: row["Primary Sales Rep: Full Name (Furigana)"] ?? null,
      est_cost: parseCurrency(row["Est. Extended Cost (Line)"]),
      ship_date: excelDateToISO(row["Date Shipped"]),
      description: row["Description"] ?? null
    }));
}

function normalizeAR(rows) {
  return rows
    .filter(row =>
      row["Document Number"] &&
      row["Transaction Type"] &&
      row["Open Balance"] &&
      row["Document Number"] !== "Total"
    )
    .map(row => ({
      context: "NETSUITE_SO_AR",
      customer: row["Customer"] ?? null,
      transaction_type: row["Transaction Type"] ?? null,
      document_number: row["Document Number"] ?? null,
      transaction_date: excelDateToISO(row["Date"]),
      due_date: excelDateToISO(row["Due Date"]),
      age_days: Number(row["Age (Present - Due)"]) || 0,
      sales_rep: row["Primary Sales Rep"] ?? null,
      open_balance: parseCurrency(row["Open Balance"]),
      po_number: row["P.O. No."] ?? null,
      bulk_billing_id: row["Bulk Billing ID"] ?? null,
      invoice_group_number: row["Invoice Group Number"] ?? null
    }));
}

function normalizeFacilisSJ(rows){
  return rows
  .filter(row => 
    row["Invoice #"] &&
    row["Invoice Date"] &&
    row["Committed"]
  )
  .map(row => ({
    context: "FACILIS_SJ",
    invoice: row["Invoice #"] ?? null,
    invoice_date: excelDateToISO(row["Invoice Date"]),
    committed: row["Committed"] ?? null,
    company: row["Company"] ?? null,
    ship_to: row["Ship To"] ?? null,
    sales: parseCurrency(row["Sales"]),
    artwork: parseCurrency(row["Artwork"]),
    freight: parseCurrency(row["Freight"]),
    tax_1: parseCurrency(row["Tax 1"]),
    total: parseCurrency(row["Total"]),
    purchases: parseCurrency(row["Purchases"]),
    inventory_charges: parseCurrency(row["Inventory Charges"]),
    misc_charges: parseCurrency(row["Misc Charges"]),
    art_charges: parseCurrency(row["Art Charges"]),
    job_gpm: parsePercent(row["Job GPM%"]),
    primary_rep: row["Primary Rep"] ?? null
  }))
}

function normalizeFacilisOJ(rows){
  return rows
  .filter(row => 
    row["Job ID"] &&
    row["Company"] &&
    row["Date"]
  )
  .map(row => ({
    context: "FACILIS_OJ",
    job_id: row["Job ID"] ?? null,
    company: row["Company"] ?? null,
    date: excelDateToISO(row["Date"]),
    status: row["Status"] ?? null,
    primary_rep: row["Primary Rep"] ?? null,
    sales: parseCurrency(row["Sales"]),
    costs: parseCurrency(row["Costs"]),
    gpm: parsePercent(row["GPM%"])
  }))
}

function parseCurrency(value) {
  if (!value) return 0;
  return Number(
    value
      .toString()
      .replace(/[,$]/g, "")
      .replace("(", "-")
      .replace(")", "")
  );
}

function excelDateToISO(value) {
  if (!value) return null;

  if (typeof value === "string") {
    const parsed = new Date(value);
    if (!isNaN(parsed)) {
      return parsed.toISOString().split("T")[0];
    }
    return null;
  }

  if (typeof value === "number") {
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    const result = new Date(excelEpoch.getTime() + value * 86400000);
    return result.toISOString().split("T")[0];
  }

  return null;
}


function parsePercent(value) {
  if (!value) return null;

  if (typeof value === "number") return value;

  return Number(value.replace("%", "").trim()) / 100;
}
